import { API_BASE_URL } from '../../env';
import { ApiReturnType } from '../../interfaces/api/api';

export default {
  create: (
    type: 'Hardware' | 'Virtual',
    wording: string,
    commercialWording: string | undefined,
    description: string,
    supplierId: number,
    categoryId: number,
    mensualRecurrency: number,
    annualRecurrency: number,
    accessCharges: number
  ): ApiReturnType => {
    const data =
      'data=' +
      encodeURIComponent(
        JSON.stringify({
          [`productReference${type}`]: {
            wording,
            commercialWording,
            description,
            mensualRecurrency,
            annualRecurrency,
            accessCharges,
            category: {
              id: categoryId,
            },
            supplier: {
              id: supplierId,
            },
          },
        })
      );

    return {
      endpoint: `${API_BASE_URL}/api/productReference${type}/new`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: data,
      method: 'POST',
    };
  },
  getCategories: (): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/api/productReferenceCategory/{productReferenceCategories{id, name}}`,
    method: 'GET',
  }),
  getSuppliers: (type: 'Hardware' | 'Virtual'): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/api/supplier${type}/{suppliers${type}{id, name}}`,
    method: 'GET',
  }),
};
